export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/black-friday-badge.9d136b92.svg","height":13,"width":94};